import type { Group, Totem } from '../types'

/** Who may edit a totem and mark it at sets. Pre-field totems fall back to
 *  their creator, mirroring the rules' own fallback. */
export function totemEditorIds(totem: Pick<Totem, 'editorIds' | 'createdBy'>): string[] {
  return totem.editorIds ?? [totem.createdBy]
}

// The group creator's override exists so a totem whose editors have all left
// can still be cleaned up — it is not a general "creator owns everything" rule.
export function canEditTotem(
  totem: Pick<Totem, 'editorIds' | 'createdBy'>,
  group: Pick<Group, 'createdBy'> | null | undefined,
  userId: string | null | undefined,
): boolean {
  if (!userId || !group) return false
  return group.createdBy === userId || totemEditorIds(totem).includes(userId)
}
